import { useEffect, useRef } from 'react';

// Workaround for the fact that we need event handlers to have a stable callback
// function so they can be removed later, but we don't want the event handler
// to be a closure over stale state. This hook allows a common pattern for
// avoiding the problem.
const useEventHandler = (
  eventName: string,
  eventHandler: (...args: unknown[]) => void,
  eventTarget: Document | Window = document
) => {
  const eventHandlerRef = useRef<(...args: unknown[]) => void>();

  useEffect(() => {
    eventHandlerRef.current = eventHandler;
  });

  useEffect(() => {
    const handleEvent = (...args: unknown[]) => {
      if (eventHandlerRef.current) eventHandlerRef.current(...args);
    };

    eventTarget.addEventListener(eventName, handleEvent);

    return () => eventTarget.removeEventListener(eventName, handleEvent);
  }, [eventName, eventTarget]);
};

export default useEventHandler;
